<div class="modal-conta" [formGroup]="form" appArrastarFecharSheet (arrastouParaFechar)="fechar()">
  <div class="modal-conta-scroll flex-direction-column gap-15">
    <div class="flex-direction-row justify-between align-center">
      <span class="modal-conta-titulo">{{ tituloModal }}</span>
      <button type="button" class="modal-conta-fechar-x" title="Fechar" (click)="fechar()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="modal-conta-corpo flex-direction-column gap-15">
      @if (!isEdicao) {
        <app-campo-segmentado formControlName="tipoConta" [opcoes]="opcoesTipoConta" [somenteLeitura]="isVisualizacao"></app-campo-segmentado>
      }

      @if (isInstagram && conectado && conta.profilePictureUrl) {
        <div class="modal-conta-instagram-perfil">
          <img [src]="conta.profilePictureUrl" alt="" class="modal-conta-instagram-avatar" />
        </div>
      }

      <app-campo-texto formControlName="nome" label="Nome"
        [placeholder]="isInstagram ? 'Aperte conectar para puxar o nome do perfil' : 'Ex: Vendas | Loja Centro'"
        [erro]="erroNome" [somenteLeitura]="isVisualizacao"></app-campo-texto>

      @if (isInstagram) {
        <app-campo-texto formControlName="numeroMetaId" label="Id Instagram"
          placeholder="Aperte conectar para puxar o nome do perfil" [somenteLeitura]="isVisualizacao"></app-campo-texto>
      } @else {
        <app-campo-texto formControlName="numero" label="Número" placeholder="+55 (11) 90000-0000"
          [erro]="erroNumero" [somenteLeitura]="isVisualizacao"></app-campo-texto>

        <app-campo-texto formControlName="whatsappBussinesId" label="WABA ID" [somenteLeitura]="isVisualizacao"></app-campo-texto>

        <app-campo-texto formControlName="numeroMetaId" label="META ID" [somenteLeitura]="isVisualizacao"></app-campo-texto>
      }

      <app-campo-texto formControlName="aplicativoId" label="ID Aplicativo" [somenteLeitura]="isVisualizacao || (isInstagram && conectado)"></app-campo-texto>

      @if (isInstagram && !conectado) {
        <app-campo-texto formControlName="clientSecret" label="Senha" tipo="senha" [somenteLeitura]="isVisualizacao"></app-campo-texto>
      }

      @if (isInstagram) {
        <div class="flex-direction-column gap-5">
          <span class="campo-label modal-conta-label-com-info">
            Redirect URL
            <img class="modal-conta-icone-info" src="./assets/icones/redesign/utils/info-field.svg" alt=""
              title="URL que o Instagram chama de volta após o login, pra confirmar a conexão. Precisa ser HTTPS (o Instagram recusa http:// mesmo em localhost) e exatamente igual à Redirect URI cadastrada no app da Meta (Meta for Developers) — copie esta URL pra lá antes de conectar." />
          </span>
          <app-campo-texto formControlName="redirectUri" [somenteLeitura]="isVisualizacao || conectado"></app-campo-texto>
        </div>
      }

      @if (isInstagram && !isVisualizacao && !conectado) {
        <app-botao label="Conectar" [icone]="''" largura="100%"
          corFundo="#ffffff" corTexto="var(--primary)" corBorda="var(--primary)"
          [disabled]="conectando" (aoClicar)="conectar()"></app-botao>
      }

      @if (mostrarFluxoESetor) {
        <app-campo-select formControlName="fluxo" [lista]="fluxos" campo="nome" label="Fluxo"
          placeholder="Selecione o fluxo" [habilitarBusca]="true" [somenteLeitura]="isVisualizacao"></app-campo-select>

        <app-campo-select formControlName="setor" [lista]="setoresComTodos" campo="nome" label="Setor"
          placeholder="Selecione o setor" [habilitarBusca]="true" [multiplo]="true" [somenteLeitura]="isVisualizacao"></app-campo-select>
      }

      <app-campo-segmentado formControlName="ativo" [opcoes]="opcoesAtivo" [somenteLeitura]="isVisualizacao"></app-campo-segmentado>

      @if (isVisualizacao) {
        <div class="modal-conta-auditoria">
          <span class="modal-conta-auditoria-titulo">Criação/Edição</span>
          <span class="modal-conta-auditoria-linha">{{ conta.usuarioCriacao?.nome || 'Sem usuário criação' }} — {{ conta.dataCriacao ? (conta.dataCriacao | date: 'dd/MM/yyyy HH:mm') : 'Sem data criação' }}</span>
          <span class="modal-conta-auditoria-linha">{{ conta.usuarioAlteracao?.nome || 'Sem usuário alteração' }} — {{ conta.dataAlteracao ? (conta.dataAlteracao | date: 'dd/MM/yyyy HH:mm') : 'Sem data alteração' }}</span>
        </div>
      }

      @if (!isVisualizacao) {
        <app-botao label="Salvar" [icone]="''" largura="100%"
          [disabled]="salvando || (isInstagram && !conectado)" (aoClicar)="salvar()"></app-botao>
        <button type="button" class="modal-conta-btn-cancelar" (click)="cancelar()">Cancelar</button>
      }
    </div>
  </div>
</div>
